{
  "financingNoAccessWarning": "You do not have the necessary rights. For this cluster, the following people can see the payout request:",
  "sendPaymentRequestLink": "Send payment request"
}
